import React, { useId } from 'react'
import { FORMATS } from './formats'
import { useLoginSysAdmin } from '../../../../../../role/hook/login-sys-admin'

// The "Format" filter beside the search box (owner 2026-10-09): any format,
// or one. Content and Templates show it beside "Available on", to super
// admins only (owner 2026-10-11: "only show the format filter to super
// admins please"). It is a developer aid -- it helps EdXR staff debug and
// find courses to test -- not a filter organizations need; the owner may
// later replace it with tags.
export const FormatSelect = ({ value, onChange }) => {
  const id = `format-filter-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`

  return (
    <div className="input-group flex-nowrap platform-filter format-filter">
      <label className="input-group-text" htmlFor={id}>
        Format
      </label>
      <select id={id} className="form-select" value={value || ''} onChange={e => onChange && onChange(e.target.value || null)}>
        <option value="">Any format</option>
        {FORMATS.map(f =>
          <option key={f.key} value={f.key} title={f.hover}>
            {f.label}
          </option>
        )}
      </select>
    </div>
  )
}

// An area's format as the person signed in gets it: the area's own
// { format, setFormat } for a super admin; for anyone else no format and no
// way to set one, so the area behaves as if none was chosen -- no Format
// filter, "v2:" stays words in the search, and a format left in the area
// narrows nothing.
//
// "Super admin" is the person's own system flag (is_sys_admin, or
// is_sys_root, which implies it) as their token carries it. An impersonated
// session's token is the impersonated person's, so it shows what they would
// see. Never an organization permission: those let a super admin pass every
// organization check, and Format is not one.
export const useFormatFilter = (format, setFormat) => {
  const superAdmin = !!useLoginSysAdmin()
  return superAdmin ? { format: format || null, setFormat } : { format: null, setFormat: undefined }
}
